import { getDynamicallyInstrumentedFunctionState } from '../V2State'
import { ApplicationState } from '../../ApplicationState'
import { DateTime } from '../../../domain/DateTime'
import { StackCall } from '../../../domain/TimelineSpan'

export interface DynamicallyInstrumentedFunctionState {
    byFullFunctionName: { [functionName: string]: number }
    byId: { [id: number]: DynamicallyInstrumentedFunction }
    loaded: boolean
    loading: boolean
    error: boolean
    errorMessage: string
}

export interface DynamicallyInstrumentedFunction {
    id: number
    className: string
    functionName: string
    origin: 'user'
    createdAt: DateTime
}

export const isFunctionAlreadyInstrumented = (state: ApplicationState, className: string | null, functionName: string): boolean => {
    const key = getByFullFunctionNameKey(className, functionName)

    return key in getDynamicallyInstrumentedFunctionState(state).byFullFunctionName
}

export const extractClassnameAndFunction = (details): [string | null, string] => {
    let className: null | string = null
    let functionName = ''

    if (details.name?.includes('::')) {
        className = details.name?.split('::')[0] ? details.namespace + '\\' + details.name?.split('::')[0] : null
        functionName = details.name?.split('::')[1] ?? details.name
    } else {
        if (details.namespace) {
            functionName = details.namespace + '\\' + details.name
        } else {
            functionName = details.name
        }
    }

    if (functionName && functionName.includes('(')) {
        functionName = functionName.split('(')[0]
    }

    return [className, functionName]
}

export const getByFullFunctionNameKey = (className: string | null, functionName: string): string => {
    let byFullFunctionNameKey = ''

    byFullFunctionNameKey = className + '::' + functionName

    if (className === null) {
        byFullFunctionNameKey = functionName
    }

    return byFullFunctionNameKey
}

export const dynamicallyInstrumentedFunctionDetailsFromStackTrace = (
    stackCall: StackCall,
): { name?: string; namespace: string; ct: number; wt: number } => {
    let name = stackCall.class ? `${stackCall.class}::${stackCall.function}` : stackCall.function
    let namespace = ''

    if (stackCall.class?.includes('\\')) {
        const parts = stackCall.class.split('\\')

        const className = parts.pop()

        namespace = parts.join('\\')
        name = `${className}::${stackCall.function}`
    }

    return {
        name,
        namespace,
        // TrackedFunction.tsx has pre-conditions on when to render the component, based on walltime and count
        wt: 10000,
        ct: 10,
    }
}
